import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'os',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: 'os',
    method: 'get',
    params: queriesParams
  })
}

export function fetchVerifySerial(serial) {
  return request({
    url: `verify-serial/${serial}`,
    method: 'get'
  })
}

export function addOs (os) {
  return request({
    method: 'post',
    url: 'os',
    data: os
  })
}

export function show (id) {
  return request({
    url: `os/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `os/${id}`,
    method: 'patch',
    data
  })
}

export function inactivate (id) {
  return request({
    url: `inactivateos/${id}`,
    method: 'patch'
  })
}

export function fetchCheckContractAndBoard (params) {
  return request({
    url: 'checkcontractandboard',
    method: 'get',
    params
  })
}

export function fetchAllPageOsList () {
  return request({
    url: 'all-page-os-list',
    method: 'get'
  })
}

export function fetchAllPageOsForm () {
  return request({
    url: 'all-page-os-form',
    method: 'get'
  })
}

export function confirmBillingEmitted (id) {
  return request({
    url: `os/confirm-billing-emitted/${id}`,
    method: 'patch'
  })
}

export function uploadAttatchment (data) {
  return request({
    method: 'post',
    url: 'os/uploadAttatchment',
    data: data.data,
    params: {
      id: data.id
    }
  })
}

export function fetchFilenamesAttachmentsByOs (id) {
  return request({
    url: `os/filenames-attatchments/${id}`,
    method: 'get'
  })
}

export function fetchAttachmentByFilename (filename) {
  return request({
    url: `os/attatchment-by-filename`,
    method: 'get',
    params: {
      filename
    }
  })
}

export function editDataOsFinished (id, data) {
  return request({
    url: `edit-data-os-finished/${id}`,
    method: 'patch',
    data
  })
}

export function editCauseOfMaintanceOsFinished (id, data) {
  return request({
    url: `edit-cause-maintance-os-finished/${id}`,
    method: 'patch',
    data
  })
}

export function fetchOsActions (id) {
  return request({
    url: `os-actions/${id}`,
    method: 'get'
  })
}

export function addOsAction (data) {
  return request({
    url: `os-action`,
    method: 'post',
    data
  })
}
